import { NavLink } from "react-router-dom";

import { List, ListItem, ListItemText, makeStyles } from "@material-ui/core";

import { Role } from "src/graphql/generated/globalTypes";
import palette from "src/styles/palette";
import { useFeatureFlag } from "src/util/featureFlags";
import { hasRole } from "src/util/roles";

import { useSubaccount } from "./SubaccountProvider";

const useStyles = makeStyles(() => ({
  sidebar: {
    minHeight: "calc(100vh - 80px)",
    width: "240px",
    paddingTop: "20px",
    background: palette.lightGray
  },
  sidebarItem: {
    fontSize: 16, // TODO: use Typography
    paddingLeft: 24
  }
}));

export default function SubaccountSidebar({
  baseUrl
}: {
  baseUrl: string;
}): JSX.Element {
  const { membership } = useSubaccount()!;
  const usageEnabled = useFeatureFlag("usage");

  const items = [
    {
      label: "Campaigns",
      path: `${baseUrl}/campaigns`
    },
    {
      label: "Admins",
      path: `${baseUrl}/admins`
    },
    ...(hasRole(membership, Role.OWNER)
      ? [
          {
            label: "Settings",
            path: `${baseUrl}/settings`
          },
          {
            label: "Integrations",
            path: `${baseUrl}/integrations`
          }
        ]
      : []),
    ...(usageEnabled
      ? [
          {
            label: "Usage",
            path: `${baseUrl}/usage`
          }
        ]
      : []),
    {
      label: "Do Not Call List",
      path: `${baseUrl}/do-not-call-list`
    }
  ];

  const classes = useStyles();
  return (
    <div className={classes.sidebar}>
      <List>
        {items.map(({ label, path }, idx) => (
          <ListItem
            key={idx}
            dense
            button
            className={classes.sidebarItem}
            component={NavLink}
            to={path}
            activeStyle={{ fontWeight: 999 }}
          >
            <ListItemText disableTypography primary={label} />
          </ListItem>
        ))}
      </List>
    </div>
  );
}
